import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import "../assets/styles/navbar.css";

const Navigation = () => (
  <Navbar bg="dark" expand="lg" fixed="top" className="py-3 custom-navbar">
    <Container>
      <Navbar.Brand href="#hero" className="me-4 brand-lockup">
        <img
          src="/Images/logo-suppoland_audiowide.png"
          alt="SUPPoland Logo"
          width="260"
          className="d-inline-block align-top img-fluid"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto align-items-lg-center nav-links-wrap">
          <Nav.Link href="#services" className="nav-section-link">Services</Nav.Link>
          <Nav.Link href="#experience" className="nav-section-link">Experience</Nav.Link>
          <Nav.Link href="#qualifications" className="nav-section-link">Safety</Nav.Link>
          <Nav.Link href="#gallery" className="nav-section-link">Gallery</Nav.Link>
          <Nav.Link href="#about" className="nav-section-link">About</Nav.Link>
          <Nav.Link href="#contact" className="nav-cta-link">Project Inquiry</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

export default Navigation;